import clsx from 'clsx';
import React from 'react';

import LongTextByWidth from '@/src/components/common/Elements/LongText/LongTextByWidth';
import { parseNumberToStringWithSeparator } from '@/src/util/numbers';
import { getValueWithEllipsis } from '@/src/util/strings';

import { DEFAULT_EMPTY_VALUE } from '../../../Config';
import Table from '../../../Elements/Table/Table';

const LineItemsSummaryTable = ({ lineItems, isDisplayView = false, isPrefilled }) => {
  return (
    <Table
      data={lineItems}
      rowClassName={clsx('tw-border-0')}
      containerClassName={clsx('tw-border-0')}
      isPrefilled={isPrefilled}
      columns={[
        // {
        //     title: 'Items',
        //     width: '16%',
        //     Cell({ entry: { item } }) {
        //         return <span> { item ? item.label || item.name : DEFAULT_EMPTY_VALUE }</span>
        //     },
        // },
        {
          title: 'Account',
          field: 'account',
          width: '140px',
          paddingClasses: clsx('tw-pl-0 tw-py-[10px]'),
          Cell({ entry: { account, accountIsAutomated } }) {
            return (
              <LongTextByWidth
                className={clsx(
                  'tw-text-cfo-black',
                  !isDisplayView &&
                    accountIsAutomated &&
                    !!account &&
                    'tw-bg-[rgba(240,232,250,1)]',
                  isPrefilled && 'tw-bg-cfo-blue-200'
                )}
                maxWidth={140}
                hasTooltip={false}
                value={account ? account.label || account.name : DEFAULT_EMPTY_VALUE}
              />
            );
          },
        },
        {
          title: 'Description',
          width: '110px',
          paddingClasses: clsx('tw-pl-0 tw-py-[10px]'),
          Cell({ entry: { description, descriptionIsAutomated } }) {
            return (
              <LongTextByWidth
                className={clsx(
                  'tw-text-cfo-black',
                  !isDisplayView &&
                    descriptionIsAutomated &&
                    !!description &&
                    'tw-bg-[rgba(240,232,250,1)]',
                  isPrefilled && 'tw-bg-cfo-blue-200'
                )}
                maxWidth={110}
                hasTooltip={false}
                value={getValueWithEllipsis(description || DEFAULT_EMPTY_VALUE, 30)}
              />
            );
          },
        },
        {
          title: 'Tax',
          width: '100px',
          paddingClasses: clsx('tw-pl-0 tw-py-[10px]'),
          Cell({ entry: { taxCode, taxCodeIsAutomated } }) {
            let label = taxCode ? taxCode.label || taxCode.name : DEFAULT_EMPTY_VALUE;

            if (typeof label === 'object') {
              label = label.name;
            }

            return (
              <LongTextByWidth
                className={clsx(
                  'tw-text-cfo-black',
                  !isDisplayView &&
                    taxCodeIsAutomated &&
                    !!taxCode &&
                    'tw-bg-[rgba(240,232,250,1)]',
                  isPrefilled && 'tw-bg-cfo-blue-200'
                )}
                maxWidth={100}
                hasTooltip={false}
                value={label}
              />
            );
          },
        },
        {
          title: 'Amount',
          textAlignment: 'tw-text-right',
          paddingClasses: clsx('tw-pl-0 tw-py-[10px]'),
          customClasses: 'tw-flex tw-justify-end tw-grow',
          Cell({ entry: { totalAmount, totalAmountIsAutomated } }) {
            return (
              <LongTextByWidth
                className={clsx(
                  'tw-text-cfo-black',
                  !isDisplayView &&
                    totalAmountIsAutomated &&
                    !!totalAmount &&
                    'tw-bg-[rgba(240,232,250,1)]',
                  isPrefilled && 'tw-bg-cfo-blue-200'
                )}
                maxWidth={160}
                hasTooltip={false}
                value={parseNumberToStringWithSeparator(totalAmount, 2)}
              />
            );
          },
        },
      ]}
    />
  );
};

LineItemsSummaryTable.defaultProps = {
  isDisplayView: false,
  isPrefilled: false,
};

export default LineItemsSummaryTable;
